import { inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

import { Store } from '@ngrx/store';

import { Router } from '@angular/router';

@Injectable()
export class BaseEffects {
  protected actions$ = inject(Actions);

  constructor(private store: Store, private router: Router) {}
}
